export type AssetType =
  | 'top_banner_desktop'
  | 'top_banner_mobile'
  | 'main_image'
  | 'pdf_cover'
  | 'pdf_back_cover'
  | 'footer_banner'
  | 'logo'
  | 'qr_code';

export interface Asset {
  id: string;
  name: string;
  type: AssetType;
  category: string;
  url: string;
  alt: string;
  active: boolean;
}

export const defaultAssets: Asset[] = [
  // ===== TOP BANNERS DESKTOP =====
  {
    id: 'asset-cam-banner-desk',
    name: 'Câmeras - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Modern%20security%20cameras%20installation%20on%20a%20contemporary%20building%20facade%2C%20multiple%20dome%20and%20bullet%20cameras%20visible%20on%20white%20walls%2C%20professional%20surveillance%20system%20setup%2C%20soft%20evening%20lighting%2C%20clean%20architectural%20background%2C%20security%20technology%20aesthetic%2C%20dark%20blue%20and%20warm%20gold%20tones%2C%20professional%20commercial%20photography%20style%2C%20high%20resolution%20sharp%20detail%2C%20simple%20background%20highlighting%20the%20camera%20system%20theme%2C%20elegant%20and%20harmonious%20atmosphere&width=1600&height=600&seq=101&orientation=landscape',
    alt: 'Banner Câmeras de Segurança Desktop',
    active: true,
  },
  {
    id: 'asset-alarm-banner-desk',
    name: 'Alarmes - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Modern%20alarm%20system%20control%20panel%20on%20a%20wall%2C%20professional%20security%20alarm%20keypad%2C%20soft%20ambient%20lighting%2C%20clean%20interior%20background%2C%20security%20technology%2C%20dark%20blue%20and%20warm%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%20sharp%20detail%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere&width=1600&height=600&seq=201&orientation=landscape',
    alt: 'Banner Alarmes Desktop',
    active: true,
  },
  {
    id: 'asset-cerca-banner-desk',
    name: 'Cerca Elétrica - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Electric%20fence%20installation%20on%20a%20modern%20property%20wall%2C%20green%20garden%20background%2C%20professional%20security%20perimeter%20system%2C%20soft%20daylight%2C%20clean%20architectural%20background%2C%20security%20technology%2C%20dark%20blue%20and%20warm%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere&width=1600&height=600&seq=301&orientation=landscape',
    alt: 'Banner Cerca Elétrica Desktop',
    active: true,
  },
  {
    id: 'asset-portoes-banner-desk',
    name: 'Portões - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Modern%20automatic%20sliding%20gate%20with%20motor%20system%2C%20contemporary%20residential%20entrance%2C%20professional%20automation%2C%20clean%20architectural%20background%2C%20dark%20blue%20evening%20sky%2C%20warm%20lighting%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20security%20technology&width=1600&height=600&seq=401&orientation=landscape',
    alt: 'Banner Portões Eletrônicos Desktop',
    active: true,
  },
  {
    id: 'asset-rural-banner-desk',
    name: 'Segurança Rural - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Rural%20farm%20property%20with%20solar%20security%20cameras%20and%20fence%2C%20wide%20green%20landscape%2C%20professional%20rural%20security%20system%2C%20golden%20sunset%20lighting%2C%20clean%20countryside%20background%2C%20dark%20blue%20and%20warm%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20security%20technology&width=1600&height=600&seq=501&orientation=landscape',
    alt: 'Banner Segurança Rural Desktop',
    active: true,
  },
  {
    id: 'asset-solar-banner-desk',
    name: 'Energia Solar - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Modern%20solar%20panel%20installation%20on%20residential%20roof%2C%20blue%20sky%20with%20clouds%2C%20professional%20energy%20technology%2C%20clean%20architectural%20background%2C%20warm%20sunlight%2C%20dark%20blue%20and%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20renewable%20energy&width=1600&height=600&seq=601&orientation=landscape',
    alt: 'Banner Energia Solar Desktop',
    active: true,
  },
  {
    id: 'asset-fibra-banner-desk',
    name: 'Fibra Óptica - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Fiber%20optic%20cables%20with%20glowing%20blue%20light%2C%20professional%20network%20technology%2C%20dark%20background%2C%20clean%20composition%2C%20internet%20infrastructure%2C%20dark%20blue%20and%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20technology&width=1600&height=600&seq=701&orientation=landscape',
    alt: 'Banner Fibra Óptica Desktop',
    active: true,
  },
  {
    id: 'asset-automacao-banner-desk',
    name: 'Automação - Banner Desktop',
    type: 'top_banner_desktop',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20interior%20with%20automation%20panels%2C%20lighting%20control%2C%20contemporary%20living%20room%2C%20professional%20home%20automation%2C%20clean%20interior%20design%2C%20dark%20blue%20and%20warm%20gold%20tones%2C%20professional%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20smart%20home&width=1600&height=600&seq=801&orientation=landscape',
    alt: 'Banner Automação Desktop',
    active: true,
  },

  // ===== TOP BANNERS MOBILE =====
  {
    id: 'asset-cam-banner-mob',
    name: 'Câmeras - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Security%20camera%20dome%20close%20up%20on%20modern%20building%2C%20professional%20surveillance%20technology%2C%20dark%20moody%20background%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20security%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background&width=1080&height=1350&seq=102&orientation=portrait',
    alt: 'Banner Câmeras Mobile',
    active: true,
  },
  {
    id: 'asset-alarm-banner-mob',
    name: 'Alarmes - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Alarm%20system%20keypad%20close%20up%2C%20dark%20background%2C%20professional%20security%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20security%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background&width=1080&height=1350&seq=202&orientation=portrait',
    alt: 'Banner Alarmes Mobile',
    active: true,
  },
  {
    id: 'asset-cerca-banner-mob',
    name: 'Cerca Elétrica - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Electric%20fence%20insulator%20close%20up%20on%20wall%2C%20dark%20background%2C%20professional%20security%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20security%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background&width=1080&height=1350&seq=302&orientation=portrait',
    alt: 'Banner Cerca Elétrica Mobile',
    active: true,
  },
  {
    id: 'asset-portoes-banner-mob',
    name: 'Portões - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Automatic%20gate%20motor%20close%20up%2C%20dark%20background%2C%20professional%20automation%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background&width=1080&height=1350&seq=402&orientation=portrait',
    alt: 'Banner Portões Mobile',
    active: true,
  },
  {
    id: 'asset-rural-banner-mob',
    name: 'Segurança Rural - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Solar%20security%20camera%20on%20rural%20fence%20post%2C%20dark%20background%2C%20professional%20rural%20security%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background%2C%20countryside&width=1080&height=1350&seq=502&orientation=portrait',
    alt: 'Banner Rural Mobile',
    active: true,
  },
  {
    id: 'asset-solar-banner-mob',
    name: 'Energia Solar - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Solar%20panel%20close%20up%20on%20roof%2C%20dark%20background%2C%20professional%20energy%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background%2C%20renewable%20energy&width=1080&height=1350&seq=602&orientation=portrait',
    alt: 'Banner Solar Mobile',
    active: true,
  },
  {
    id: 'asset-fibra-banner-mob',
    name: 'Fibra Óptica - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Fiber%20optic%20cable%20bundle%20close%20up%2C%20glowing%20blue%20light%2C%20dark%20background%2C%20professional%20network%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background%2C%20internet&width=1080&height=1350&seq=702&orientation=portrait',
    alt: 'Banner Fibra Mobile',
    active: true,
  },
  {
    id: 'asset-automacao-banner-mob',
    name: 'Automação - Banner Mobile',
    type: 'top_banner_mobile',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Smart%20home%20control%20panel%20on%20wall%2C%20dark%20background%2C%20professional%20automation%20technology%2C%20warm%20gold%20accent%20lighting%2C%20portrait%20orientation%2C%20high%20detail%2C%20cinematic%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20dark%20blue%20and%20gold%20tones%2C%20simple%20background%2C%20smart%20home&width=1080&height=1350&seq=802&orientation=portrait',
    alt: 'Banner Automação Mobile',
    active: true,
  },

  // ===== MAIN IMAGES =====
  {
    id: 'asset-cam-main',
    name: 'Câmeras - Imagem Principal',
    type: 'main_image',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Modern%20residential%20house%20exterior%20with%20multiple%20security%20cameras%20visible%2C%20professional%20surveillance%20installation%2C%20evening%20twilight%2C%20warm%20home%20lights%2C%20clean%20architecture%2C%20security%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20sky%20with%20warm%20golden%20accents%2C%20simple%20background%20emphasizing%20the%20house%2C%20high%20resolution%20sharp%20detail%2C%20elegant%20and%20harmonious%20atmosphere&width=1400&height=900&seq=103&orientation=landscape',
    alt: 'Imagem Principal Câmeras',
    active: true,
  },
  {
    id: 'asset-alarm-main',
    name: 'Alarmes - Imagem Principal',
    type: 'main_image',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Modern%20home%20interior%20with%20alarm%20sensors%20and%20control%20panel%2C%20professional%20security%20installation%2C%20warm%20lighting%2C%20clean%20interior%2C%20security%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere&width=1400&height=900&seq=203&orientation=landscape',
    alt: 'Imagem Principal Alarmes',
    active: true,
  },
  {
    id: 'asset-cerca-main',
    name: 'Cerca Elétrica - Imagem Principal',
    type: 'main_image',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Modern%20residential%20fence%20with%20electric%20security%20system%2C%20professional%20perimeter%20protection%2C%20green%20garden%2C%20warm%20lighting%2C%20clean%20architecture%2C%20security%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere&width=1400&height=900&seq=303&orientation=landscape',
    alt: 'Imagem Principal Cerca',
    active: true,
  },
  {
    id: 'asset-portoes-main',
    name: 'Portões - Imagem Principal',
    type: 'main_image',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Modern%20residential%20entrance%20with%20automatic%20gate%2C%20professional%20automation%20system%2C%20elegant%20driveway%2C%20warm%20lighting%2C%20clean%20architecture%2C%20automation%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere&width=1400&height=900&seq=403&orientation=landscape',
    alt: 'Imagem Principal Portões',
    active: true,
  },
  {
    id: 'asset-rural-main',
    name: 'Segurança Rural - Imagem Principal',
    type: 'main_image',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Wide%20rural%20farm%20entrance%20with%20automated%20gate%20and%20security%20cameras%2C%20green%20fields%2C%20professional%20rural%20security%2C%20warm%20sunset%20lighting%2C%20clean%20countryside%2C%20security%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere&width=1400&height=900&seq=503&orientation=landscape',
    alt: 'Imagem Principal Rural',
    active: true,
  },
  {
    id: 'asset-solar-main',
    name: 'Energia Solar - Imagem Principal',
    type: 'main_image',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Modern%20house%20with%20solar%20panels%20on%20roof%2C%20professional%20energy%20installation%2C%20blue%20sky%2C%20warm%20sunlight%2C%20clean%20architecture%2C%20renewable%20energy%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere&width=1400&height=900&seq=603&orientation=landscape',
    alt: 'Imagem Principal Solar',
    active: true,
  },
  {
    id: 'asset-fibra-main',
    name: 'Fibra Óptica - Imagem Principal',
    type: 'main_image',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Modern%20data%20center%20with%20fiber%20optic%20connections%2C%20professional%20network%20infrastructure%2C%20blue%20led%20lights%2C%20clean%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere%2C%20technology&width=1400&height=900&seq=703&orientation=landscape',
    alt: 'Imagem Principal Fibra',
    active: true,
  },
  {
    id: 'asset-automacao-main',
    name: 'Automação - Imagem Principal',
    type: 'main_image',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20living%20room%2C%20automated%20lighting%20and%20curtains%2C%20professional%20home%20automation%2C%20warm%20interior%2C%20clean%20architecture%2C%20smart%20technology%2C%20photorealistic%20style%2C%20dark%20blue%20with%20warm%20golden%20accents%2C%20simple%20background%2C%20high%20resolution%2C%20elegant%20atmosphere%2C%20automation&width=1400&height=900&seq=803&orientation=landscape',
    alt: 'Imagem Principal Automação',
    active: true,
  },

  // ===== PDF COVERS =====
  {
    id: 'asset-cam-pdf-cover',
    name: 'Câmeras - PDF Capa',
    type: 'pdf_cover',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Security%20camera%20system%20on%20dark%20background%2C%20professional%20surveillance%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20security%20technology&width=1600&height=900&seq=104&orientation=landscape',
    alt: 'PDF Capa Câmeras',
    active: true,
  },
  {
    id: 'asset-alarm-pdf-cover',
    name: 'Alarmes - PDF Capa',
    type: 'pdf_cover',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Alarm%20system%20equipment%20on%20dark%20background%2C%20professional%20security%20devices%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20security%20technology&width=1600&height=900&seq=204&orientation=landscape',
    alt: 'PDF Capa Alarmes',
    active: true,
  },
  {
    id: 'asset-cerca-pdf-cover',
    name: 'Cerca Elétrica - PDF Capa',
    type: 'pdf_cover',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Electric%20fence%20system%20on%20dark%20background%2C%20professional%20security%20perimeter%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20security%20technology&width=1600&height=900&seq=304&orientation=landscape',
    alt: 'PDF Capa Cerca',
    active: true,
  },
  {
    id: 'asset-portoes-pdf-cover',
    name: 'Portões - PDF Capa',
    type: 'pdf_cover',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Automatic%20gate%20system%20on%20dark%20background%2C%20professional%20automation%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20automation%20technology&width=1600&height=900&seq=404&orientation=landscape',
    alt: 'PDF Capa Portões',
    active: true,
  },
  {
    id: 'asset-rural-pdf-cover',
    name: 'Segurança Rural - PDF Capa',
    type: 'pdf_cover',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Rural%20security%20system%20on%20dark%20background%2C%20solar%20cameras%20and%20electric%20fence%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20rural%20security%20technology&width=1600&height=900&seq=504&orientation=landscape',
    alt: 'PDF Capa Rural',
    active: true,
  },
  {
    id: 'asset-solar-pdf-cover',
    name: 'Energia Solar - PDF Capa',
    type: 'pdf_cover',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Solar%20panels%20on%20dark%20background%2C%20professional%20energy%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20renewable%20energy%20technology&width=1600&height=900&seq=604&orientation=landscape',
    alt: 'PDF Capa Solar',
    active: true,
  },
  {
    id: 'asset-fibra-pdf-cover',
    name: 'Fibra Óptica - PDF Capa',
    type: 'pdf_cover',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Fiber%20optic%20network%20on%20dark%20background%2C%20professional%20network%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20fiber%20technology&width=1600&height=900&seq=704&orientation=landscape',
    alt: 'PDF Capa Fibra',
    active: true,
  },
  {
    id: 'asset-automacao-pdf-cover',
    name: 'Automação - PDF Capa',
    type: 'pdf_cover',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Smart%20home%20automation%20system%20on%20dark%20background%2C%20professional%20automation%20equipment%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20premium%20commercial%20photography%2C%20high%20resolution%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20smart%20home%20technology&width=1600&height=900&seq=804&orientation=landscape',
    alt: 'PDF Capa Automação',
    active: true,
  },

  // ===== PDF BACK COVERS =====
  {
    id: 'asset-cam-pdf-back',
    name: 'Câmeras - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Security%20technology%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20security%20concept&width=1600&height=900&seq=105&orientation=landscape',
    alt: 'PDF Contracapa Câmeras',
    active: true,
  },
  {
    id: 'asset-alarm-pdf-back',
    name: 'Alarmes - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Security%20alarm%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20alarm%20concept&width=1600&height=900&seq=205&orientation=landscape',
    alt: 'PDF Contracapa Alarmes',
    active: true,
  },
  {
    id: 'asset-cerca-pdf-back',
    name: 'Cerca Elétrica - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Electric%20fence%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20perimeter%20security%20concept&width=1600&height=900&seq=305&orientation=landscape',
    alt: 'PDF Contracapa Cerca',
    active: true,
  },
  {
    id: 'asset-portoes-pdf-back',
    name: 'Portões - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Automation%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20automation%20concept&width=1600&height=900&seq=405&orientation=landscape',
    alt: 'PDF Contracapa Portões',
    active: true,
  },
  {
    id: 'asset-rural-pdf-back',
    name: 'Segurança Rural - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Rural%20landscape%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20rural%20security%20concept&width=1600&height=900&seq=505&orientation=landscape',
    alt: 'PDF Contracapa Rural',
    active: true,
  },
  {
    id: 'asset-solar-pdf-back',
    name: 'Energia Solar - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Solar%20energy%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20solar%20energy%20concept&width=1600&height=900&seq=605&orientation=landscape',
    alt: 'PDF Contracapa Solar',
    active: true,
  },
  {
    id: 'asset-fibra-pdf-back',
    name: 'Fibra Óptica - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Fiber%20optic%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20fiber%20technology%20concept&width=1600&height=900&seq=705&orientation=landscape',
    alt: 'PDF Contracapa Fibra',
    active: true,
  },
  {
    id: 'asset-automacao-pdf-back',
    name: 'Automação - PDF Contracapa',
    type: 'pdf_back_cover',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Smart%20home%20abstract%20background%2C%20dark%20blue%20gradient%20with%20subtle%20golden%20light%20rays%2C%20minimalist%20professional%20design%2C%20premium%20feel%2C%20dark%20moody%20atmosphere%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20automation%20concept&width=1600&height=900&seq=805&orientation=landscape',
    alt: 'PDF Contracapa Automação',
    active: true,
  },

  // ===== FOOTER BANNERS =====
  {
    id: 'asset-cam-footer',
    name: 'Câmeras - Rodapé Banner',
    type: 'footer_banner',
    category: 'cameras',
    url: 'https://readdy.ai/api/search-image?query=Security%20cameras%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20security%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=106&orientation=landscape',
    alt: 'Rodapé Banner Câmeras',
    active: true,
  },
  {
    id: 'asset-alarm-footer',
    name: 'Alarmes - Rodapé Banner',
    type: 'footer_banner',
    category: 'alarmes',
    url: 'https://readdy.ai/api/search-image?query=Alarm%20system%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20security%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=206&orientation=landscape',
    alt: 'Rodapé Banner Alarmes',
    active: true,
  },
  {
    id: 'asset-cerca-footer',
    name: 'Cerca Elétrica - Rodapé Banner',
    type: 'footer_banner',
    category: 'cerca-eletrica',
    url: 'https://readdy.ai/api/search-image?query=Electric%20fence%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20security%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=306&orientation=landscape',
    alt: 'Rodapé Banner Cerca',
    active: true,
  },
  {
    id: 'asset-portoes-footer',
    name: 'Portões - Rodapé Banner',
    type: 'footer_banner',
    category: 'portoes-eletronicos',
    url: 'https://readdy.ai/api/search-image?query=Automatic%20gate%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20automation%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=406&orientation=landscape',
    alt: 'Rodapé Banner Portões',
    active: true,
  },
  {
    id: 'asset-rural-footer',
    name: 'Segurança Rural - Rodapé Banner',
    type: 'footer_banner',
    category: 'seguranca-rural',
    url: 'https://readdy.ai/api/search-image?query=Rural%20security%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20rural%20security%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=506&orientation=landscape',
    alt: 'Rodapé Banner Rural',
    active: true,
  },
  {
    id: 'asset-solar-footer',
    name: 'Energia Solar - Rodapé Banner',
    type: 'footer_banner',
    category: 'energia-solar',
    url: 'https://readdy.ai/api/search-image?query=Solar%20panel%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20energy%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=606&orientation=landscape',
    alt: 'Rodapé Banner Solar',
    active: true,
  },
  {
    id: 'asset-fibra-footer',
    name: 'Fibra Óptica - Rodapé Banner',
    type: 'footer_banner',
    category: 'fibra-optica',
    url: 'https://readdy.ai/api/search-image?query=Fiber%20optic%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20network%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=706&orientation=landscape',
    alt: 'Rodapé Banner Fibra',
    active: true,
  },
  {
    id: 'asset-automacao-footer',
    name: 'Automação - Rodapé Banner',
    type: 'footer_banner',
    category: 'automacao',
    url: 'https://readdy.ai/api/search-image?query=Smart%20home%20silhouette%20on%20dark%20background%2C%20subtle%20golden%20lighting%2C%20professional%20footer%20banner%20style%2C%20dark%20blue%20gradient%2C%20simple%20background%2C%20elegant%20and%20harmonious%20atmosphere%2C%20high%20resolution%2C%20minimal%20composition%2C%20premium%20automation%20aesthetic%2C%20dark%20moody%20atmosphere&width=1600&height=400&seq=806&orientation=landscape',
    alt: 'Rodapé Banner Automação',
    active: true,
  },

  // ===== LOGOS =====
  {
    id: 'asset-logo-default',
    name: 'Logo Padrão',
    type: 'logo',
    category: 'general',
    url: 'https://readdy.ai/api/search-image?query=Professional%20company%20logo%20placeholder%2C%20elegant%20dark%20blue%20and%20gold%20emblem%2C%20minimalist%20security%20company%20logo%2C%20geometric%20shield%20shape%2C%20premium%20business%20logo%2C%20clean%20background%2C%20dark%20moody%20atmosphere%2C%20simple%20and%20harmonious&width=400&height=400&seq=901&orientation=squarish',
    alt: 'Logo Padrão',
    active: true,
  },

  // ===== QR CODES =====
  {
    id: 'asset-qr-default',
    name: 'QR Code Padrão',
    type: 'qr_code',
    category: 'general',
    url: 'https://readdy.ai/api/search-image?query=QR%20code%20mockup%20on%20dark%20background%2C%20simple%20black%20and%20white%20QR%20code%20square%2C%20clean%20minimalist%20design%2C%20professional%20business%20card%20style%2C%20no%20text%20around%20the%20QR%20code%2C%20high%20contrast%20black%20and%20white%20pattern&width=200&height=200&seq=2&orientation=squarish',
    alt: 'QR Code Padrão',
    active: true,
  },
];

/**
 * Busca assets por categoria.
 */
export function findAssetsByCategory(category: string): Asset[] {
  return defaultAssets.filter((a) => a.category === category || a.category === 'general');
}

/**
 * Busca assets por tipo.
 */
export function findAssetsByType(type: AssetType): Asset[] {
  return defaultAssets.filter((a) => a.type === type);
}

/**
 * Busca assets ativos por categoria e tipo.
 */
export function findActiveAssets(category: string, type: AssetType): Asset[] {
  return defaultAssets.filter((a) => a.active && a.type === type && (a.category === category || a.category === 'general'));
}

/**
 * Busca asset pelo ID.
 */
export function findAssetById(id: string): Asset | undefined {
  return defaultAssets.find((a) => a.id === id);
}

/**
 * Lista todos os assets ativos.
 */
export function listActiveAssets(): Asset[] {
  return defaultAssets.filter((a) => a.active);
}